import { render, staticRenderFns } from "./SortPage.vue?vue&type=template&id=78bc7401&scoped=true"
import script from "./SortPage.vue?vue&type=script&lang=js"
export * from "./SortPage.vue?vue&type=script&lang=js"
import style0 from "./SortPage.vue?vue&type=style&index=0&id=78bc7401&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc7401",
  null
  
)

export default component.exports